import React from 'react'
import Pro from '../ProImg/Pro.png'
import beach from '../ProImg/beach.png'
import mount from '../ProImg/mount.png'
import pool from '../ProImg/pool.png'
import pool1 from '../ProImg/pool1.jpg'
import hotel1 from '../ProImg/hotel1.png'
import sit from '../ProImg/sit.png'
import sit1 from '../ProImg/sit1.png'
import Header from '../Header'
import Footer from '../Footer'
import ScrollButtons from '../ScrollButtons'


export default function Gallery() {
  return (
    <div>
      <Header/>
      <ScrollButtons/>
        <div className='container-fluid mt-5'>
        <div className='row'>
            <div className='col-sm-12'>
                <h2 className='a1 text-center'>Gallery</h2>
            </div>
        </div>

<div className='row'>
    <div className='col-sm-2'></div>
    <div className='col-sm-8'>
    <img src={Pro} alt='' className='img-fluid'/>
    </div>
    <div className='col-sm-2'></div>
</div>
         {/* row 1  */}

  <div className='row p-0 m-0 px-5 mt-5'>
    <div className='col-sm-4'>
    <div className='card2'>
  <img src={beach} alt='' className='img-fluid'/>
  
 </div>
    </div> 
    <div className='col-sm-4'>
    <div className='card2'>
  <img src={pool} alt='' className='img-fluid'/>
  
 </div>
    </div>

    <div className='col-sm-4'>
    <div className='card2'>
  <img src={sit} alt='' className='img-fluid'/>
  
 </div>
    </div>
    
  </div>
  {/* row 2  */}
  <div className='row p-0 m-0 px-5 mt-5'>
    <div className='col-sm-4'>
    <div className='card2'>
  <img src={pool1} alt='' className='img-fluid'/>
  
 </div>
    </div> 
    <div className='col-sm-4'>
    <div className='card2'>
  <img src={hotel1} alt='' className='img-fluid'/>
  
 </div>
    </div>

    <div className='col-sm-4'>
    <div className='card2'>
  <img src={sit1} alt='' className='img-fluid'/>
  
 </div>
    </div>
    
  </div>
{/* row 3  */}
  <div className='row p-0 m-0 px-5 mt-5'>
    <div className='col-sm-4'>
    <div className='card2'>
  <img src={hotel1} alt='' className='img-fluid'/>
  
 </div>
    </div> 
    <div className='col-sm-4'>
    <div className='card2'>
  <img src={sit1} alt='' className='img-fluid' />
  
 </div>
    </div>

    <div className='col-sm-4'>
    <div className='card2'>
  <img src={beach} alt='' className='img-fluid' />
  
 </div>
    </div>
    
  </div>
  {/* row 4 */}
  <div className='row p-0 m-0 px-5 mt-5'>
    <div className='col-sm-4'>
    <div className='card2'>
  <img src={pool} alt='' className='img-fluid'/>
  
 </div>
    </div> 
    <div className='col-sm-4'>
    <div className='card2'>
  <img src={beach} alt='' className='img-fluid'/>
  
 </div>
    </div>

    <div className='col-sm-4'>
    <div className='card2'>
  <img src={pool} alt='' className='img-fluid' />
  
 </div>
    </div>
    
  </div>
  </div>
  <Footer/>
    </div>
  )
}
